module.exports = "<div class=\"quality-modal\">\n  <span class=\"switchimg\"></span> <span class=\"current-quality-tag\"></span> , <span class=\"wait\"></span>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/lesson/play/components/aliplayer/components/QualityComponent/quality-modal.html
// module id = Q3RN
// module chunks = 1